<h2>{{ 'settings.tax-return-alias-types' | transloco: {taxReturnAlias} }}</h2>

<p>
  {{ 'settings.tax-return-alias-types-allow-tax-return-alias-s-to-have-different-sets-of-questions-you-may-set-up-the-question-sets-from-tax-return-alias-builder-section' | transloco: {taxReturnAlias} }}
</p>

<div class="config-row">
  <div
    class="ui toggle checkbox config-toggle"
    (click)="toggleConfigExportMode()"
  >
    <input type="checkbox" [ngModel]="configExportMode" />
    <label>{{ "settings.export-config-mode" | transloco }}</label>
  </div>
</div>

<div class="tax-return-type-filters">
  @if (configExportMode) {
  <div class="config-date">
    <input
      type="date"
      placeholder="From date"
      [(ngModel)]="configExportDate"
      onkeydown="return false"
      [disabled]="loading"
      (change)="filterTaxReturnTypeOnDateChange()"
    />
  </div>
  } @if (configExportMode) {
  <button
    class="ui primary button background tiny config-button"
    (click)="openConfigExportConfimationModal()"
  >
    {{ "settings.download-config" | transloco }}
  </button>
  } @if (!configExportMode) {
  <div class="tax-return-type-keyword-filter">
    <div class="ui left  fluid input">
      <i class="search icon tax-return-type-input-icon"></i>
      <input
        type="text"
        [(ngModel)]="taxReturnTypeSearch"
        placeholder="Search Types"
      />
    </div>
  </div>
  } @if (!configExportMode) {
  <div class="tax-return-type-actions">
    @if (!isProductionMode) {
    <button
      class="ui primary background button tiny"
      (click)="addTaxReturnType()"
    >
      {{ 'settings.add-tax-return-alias-type' | transloco: {taxReturnAlias} }}
    </button>
    }
  </div>
  }
</div>

@if (taxReturnTypes?.length == 0 || (taxReturnTypesForConfigExport?.length == 0
&& configExportMode)) {
<div id="no-results">
  {{ "settings.no-tax-return-types-found" | transloco }}
</div>
} @if (taxReturnTypes?.length > 0 && !configExportMode) {
<table class="ui striped table">
  <thead>
    <tr class="title">
      <th rowspan="2">{{ "settings.name" | transloco }}</th>
      <th rowspan="2">{{ "settings.key" | transloco }}</th>
      <th rowspan="2">{{ "settings.number-of-subtypes" | transloco }}</th>
      <th rowspan="2">
        <div class="testing">{{ "settings.status" | transloco }}</div>
      </th>
      @if (syncToOneTeamEnabled) {
      <th colspan="3" style="text-align:center">
        {{ "settings.OneTeam" | transloco }}
      </th>
      } @if (!isProductionMode) {
      <th rowspan="2"></th>
      }
      <th rowspan="2"></th>
    </tr>
    <tr class="title">
      @if (syncToOneTeamEnabled) {
      <th>{{ "settings.Engagement-Type" | transloco }}</th>
      } @if (syncToOneTeamEnabled) {
      <th>{{ "settings.Display-Name" | transloco }}</th>
      } @if (syncToOneTeamEnabled) {
      <th class="oneteam-sync">{{ "settings.Sync-Enabled" | transloco }}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (trt of taxReturnTypes | keyWord: ['type',
    'alias']:taxReturnTypeSearch; track trt) {
    <tr>
      <td>{{ trt.type }}</td>
      <td>{{ trt.alias }}</td>
      <td>{{ trt.subtypeCount }}</td>
      <td>{{ trt.status == 0 ? "Active" : "Inactive" }}</td>
      @if (syncToOneTeamEnabled) {
      <td>{{ trt.oneTeamEngagementType }}</td>
      } @if (syncToOneTeamEnabled) {
      <td>{{ trt.oneTeamEngagementTypeDisplayName }}</td>
      } @if (syncToOneTeamEnabled) {
      <td>
        <input
          type="checkbox"
          [ngModel]="!!trt.syncToOneTeam"
          (ngModelChange)="trt.syncToOneTeam = $event"
          disabled="true"
        />
      </td>
      } @if (!isProductionMode) {
      <td class="edit" align="right" (click)="editTaxReturnType(trt)">
        {{ "settings.edit" | transloco }}
      </td>
      }
      <td class="edit" align="right" [routerLink]="[trt.id, 'subtypes']">
        {{ "settings.view-subtypes" | transloco }}
      </td>
    </tr>
    }
  </tbody>
</table>
} @if (taxReturnTypesForConfigExport?.length > 0 && configExportMode) {
<table id="list" width="100%" cellspacing="0">
  <thead>
    <tr>
      <td>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="entireListSelected"
            (change)="entireListSelection()"
          /><label>&nbsp;</label>
        </div>
      </td>
      <td width="500px">{{ "settings.name" | transloco }}</td>
      <td width="200px" class="no-wrap">{{ "settings.key" | transloco }}</td>
      <td width="200px" class="no-wrap">{{ "settings.status" | transloco }}</td>
      <td>{{ "settings.created" | transloco }}</td>
      <td>{{ "settings.updated" | transloco }}</td>
    </tr>
  </thead>
  <tbody>
    @for (taxReturnType of taxReturnTypesForConfigExport; track taxReturnType) {
    <tr>
      <td>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="taxReturnType.selected"
            (change)="listSelection()"
          /><label>&nbsp;</label>
        </div>
      </td>
      <td>{{ taxReturnType?.type }}</td>
      <td>{{ taxReturnType?.alias }}</td>
      <td>{{ taxReturnType?.status == 0 ? "Active" : "Inactive" }}</td>
      <td>{{ taxReturnType?.displayCreatedAt }}</td>
      <td>{{ taxReturnType?.displayUpdatedAt }}</td>
    </tr>
    }
  </tbody>
</table>
}

<div #configExportConfimationModal class="ui modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>
    {{ "settings.please-confirm-the-selected-config-to-export" | transloco }}
  </p>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>{{ "settings.name" | transloco }}</th>
        <th>{{ "settings.updated" | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (taxReturnType of selectedTaxReturnTypes; track taxReturnType) {
      <tr>
        <td>{{ taxReturnType?.type }}</td>
        <td>{{ taxReturnType.displayUpdatedAt }}</td>
      </tr>
      }
    </tbody>
  </table>

  @if (!selectedTaxReturnTypes.length) {
  <p>{{ "settings.nothing-selected" | transloco }}</p>
  }
  <button
    class="ui primary button background tiny config-button"
    [ngClass]="{ disabled: !selectedTaxReturnTypes.length }"
    (click)="downloadConfig()"
  >
    {{ "settings.download" | transloco }}
  </button>
</div>
